import { RightDrawerFilters } from './RightDrawerFilters';
import { RightDrawerTable } from './RightDrawerTable';
import { memo } from 'react';
import type { RightDrawerCatalogSectionContract } from './catalogSection.types';
import { FF } from 'modules/feature-flags/featureFlags.generated';
import { useFeatureFlagEnabled } from 'modules/feature-flags/useFeatureFlagEnabled';

type Props = {
  expanded: boolean;
  basePath: string;
  catalogSection: RightDrawerCatalogSectionContract;
};

export const RightDrawerSectionContent = memo(
  ({ expanded, basePath, catalogSection }: Props): React.ReactElement => {
    const { tab, tabProps, onRowClick, onRowDoubleClick, starredId } = catalogSection;
    const [isInsertColumnEnabled] = useFeatureFlagEnabled(FF.REPORTER_NESTED_MACROS);

    const {
      ownerScope,
      setOwnerScope,
      studyRelevance,
      setStudyRelevance,
      search,
      setSearch,
      onLoadMore,
      cursor,
      items,
      isLoading,
    } = tabProps;

    return (
      <>
        {expanded && (
          <RightDrawerFilters
            search={search}
            setSearch={setSearch}
            studyRelevance={studyRelevance}
            setStudyRelevance={setStudyRelevance}
            ownerScope={ownerScope}
            setOwnerScope={setOwnerScope}
            activeTab={tab}
          />
        )}
        <RightDrawerTable
          items={items ?? []}
          isLoading={isLoading}
          onLoadMore={onLoadMore}
          activeTab={tab}
          basePath={basePath}
          starredId={starredId}
          onRowClick={onRowClick}
          onRowDoubleClick={onRowDoubleClick}
          hasMoreData={cursor != null}
          sorting={tabProps.order}
          onSortingChange={tabProps.setOrder}
          isInsertColumnEnabled={isInsertColumnEnabled}
        />
      </>
    );
  }
);

RightDrawerSectionContent.displayName = 'RightDrawerSectionContent';
